import { baseConfig as bridge } from './baseConfig';
import { IS_IOS } from '../../constants';
import utils from '../utils';

const isClient = typeof window !== 'undefined';
const win = isClient ? window : {};
const CALLBACK_NAMESPACE = '__JSBridge_Callback__';
const sendMessageQueue = [];
let MESSAGEID = 0;
const SCHEME = bridge.scheme;

export const JSBridge = {
  debug: process.env.NODE_ENV === 'development',
};

/**
* @description 获取数据类型
* @param {any} item 传入参数
* @returns String Function Boolean Object Number
*/
export function getParamType(item) {
  if (item === null) {
    return null;
  }
  if (item === undefined) {
    return undefined;
  }
  return Object.prototype.toString.call(item).slice(8, -1);
}

/**
* @description 处理回调函数
* @param {function} callback 真正的回调函数 处理成字符串返回给native 如__JSBridge_Callback__1547016551717
* @param {String} callback 传入的回调函数名 如果不是全局需要处理成全局
* @param {Boolean} destroy 是否保留callback下次使用 默认销毁
* @returns {String} 返回字符串用于传给native
*/
export function callbackHandler(callback) {
  const callbackUniqueId = new Date().getTime();
  MESSAGEID += 1;
  const name = CALLBACK_NAMESPACE + callbackUniqueId + MESSAGEID;
  const cbType = getParamType(callback);
  if (cbType !== 'Function') {
    return '';
  }
  const tmpFunc = callback;
  win[name] = (event, ev) => {
    if (event && ev) {
      tmpFunc(ev);
    } else {
      tmpFunc(event);
    }
  };
  // eslint-disable-next-line
  return name;
}

/**
* @description 打包消息成native需要的形式
* @param {any} params 业务传参
* @returns 返回拼接好的消息体
*/
export function packMessage(params = {}) {
  let message = `${SCHEME}`;
  const { query, path } = params;
  if (path) {
    message += `${path}`;
  } else {
    return '';
  }
  if (query && !utils.isObjEmpty(query)) {
    message += `?${utils.objToStr(query)}`;
  }
  return message;
}

/**
* @description iOS底层通信 使用webkit的messageHandlers方法
* @param {any} params
*/
function iOSBridge(params) {
  bridge.ios(params);
}

/**
* @description Android底层通信
*/
function androidBridge(params) {
  bridge.android(params);
}

/**
* @description 判断底层调用方iOS或者Android
* @param {any} message 发送消息
* @returns
*/
function bridgeNative(message) {
  if (IS_IOS) {
    return iOSBridge(message);
  }
  return androidBridge(message);
}

/**
* @description 请求(处理)消息队列
* @returns
*/
function fetchQueue() {
  if (sendMessageQueue.length <= 0) {
    // 如果消息队列为空 则返回
    return;
  }
  const message = sendMessageQueue.shift(); // 删除队列第一个，并返回第一个
  bridgeNative(message);
  fetchQueue();
}

/**
* @description 发送消息到队列中
* @param {any} message
*/
export function sendMessage(message) {
  sendMessageQueue.push(message);
  fetchQueue();
}

/**
* @description 分发Android和iOS底层交互
* @param {Object} params 业务方传参
* @param {callback} callback 回调函数
* @param
*/
export function nativeBridge(params) {
  const { query, callback } = params;
  if (callback) {
    query.callback = callbackHandler(callback);
  }
  const message = packMessage(params);
  sendMessage(message);
}
